import React, { useState } from "react";
import { Drawer } from "antd";
import { useParams, useHistory } from "react-router-dom";
import { useToggle } from "../../modules";

const Referee = ({ onSave, record = { refName: "John Doe", phoneNo: "0712345678", title: "Lecturer", organization: "UON", email: "ref@gmail.com" } }) => {
    const [refName, setRefName] = useState(record?.refName)
    const [phoneNo, setPhoneNo] = useState(record?.phoneNo)
    const [title, setTitle] = useState(record?.title)
    const [organization, setOrganization] = useState(record?.organization)
    const [email, setEmail] = useState(record?.email)
    const [visible, toggleVisible] = useToggle(true)
    const history = useHistory()
    const { index } = useParams();


    const close = () => {
        toggleVisible(false)
        setTimeout(() => history.goBack(), 300);
    }

    const modify = (e) => {
      switch (e.target.name) {
        case "refName":
          setRefName(e.target.value);
          break;

        case "phoneNo":
          setPhoneNo(e.target.value);
          break;

        case "title":
          setTitle(e.target.value);
          break;

        case "email":
          setEmail(e.target.value);
          break;

        case "organization":
          setOrganization(e.target.value);
          break;

        default:
          break;
      }
    };

    const save = () => {
        onSave({
            refName,
            phoneNo,
            title,
            organization,
            email
        },
            index
        );
            close();
    }
    return (
      <Drawer
        closable
        maskClosable
        visible={visible}
        onClose={close}
        footer={
          <div className="w-full text-right">
            <button
              onClick={save}
              className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            >
              Save
            </button>
          </div>
        }
        width="30%"
      >
        <p className="font-extrabold text-2xl mb-0">
          {record ? "Edit" : "Add"} Referee
        </p>
        <div className="flex flex-wrap mt-3">
          <div className="w-full px-3 mb-1">
            <>
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-refName"
              >
                Name
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-refName"
                name="refName"
                value={refName}
                onChange={modify}
                type="text"
                placeholder="Referee Name"
              />
            </>
          </div>
          <div className="w-full px-3 mb-1">
            <>
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-refName"
              >
                Phone Number
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-phoneNo"
                name="phoneNo"
                value={phoneNo}
                onChange={modify}
                type="number"
                placeholder="Phone Number"
              />
            </>
          </div>
          <div className="w-full px-3 mb-1">
            <>
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-refName"
              >
                Title
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-title"
                name="title"
                value={title}
                onChange={modify}
                type="text"
                placeholder="Title"
              />
            </>
          </div>
          <div className="w-full px-3 mb-1">
            <>
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-organzation"
              >
                Organization
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-organization"
                name="organization"
                value={organization}
                onChange={modify}
                type="text"
                placeholder="Organization"
              />
            </>
          </div>
          <div className="w-full px-3 mb-1">
            <>
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-email"
              >
                Email
              </label>
              <input
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-email"
                name="email"
                value={ email}
                onChange={modify}
                type="email"
                placeholder="Email"
              />
            </>
          </div>
        </div>
      </Drawer>
    );
}

export default Referee;